import React, { useState, useEffect } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    Slide,
    IconButton,
    Typography,
    Box
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const DIALOG_PAPER_PROPS = {
    style: { borderRadius: 15, padding: '10px' },
};

const CLOSE_BTN_SX = { color: 'grey.500' };

const ConveniosForm = ({ open, handleClose, handleSubmit, initialData }) => {
    const [nombre, setNombre] = useState('');
    const [error, setError] = useState(false);

    useEffect(() => {
        if (initialData) {
            setNombre(initialData.nombre || '');
        } else {
            setNombre('');
        }
        setError(false);
    }, [initialData, open]);

    const validate = () => {
        if (!nombre.trim()) {
            setError("El nombre es obligatorio");
            return false;
        }
        if (nombre.trim().length < 3) {
            setError("El nombre debe tener al menos 3 caracteres");
            return false;
        }
        if (nombre.trim().length > 100) {
            setError("El nombre no puede exceder los 100 caracteres");
            return false;
        }
        return true;
    };

    const onSubmit = (e) => {
        e.preventDefault();
        if (validate()) {
            handleSubmit({ nombre: nombre.trim() });
        }
    };

    return (
        <Dialog
            open={open}
            TransitionComponent={Transition}
            keepMounted
            onClose={handleClose}
            aria-describedby="alert-dialog-slide-description"
            fullWidth
            maxWidth="sm"
            PaperProps={DIALOG_PAPER_PROPS}
        >
            <DialogTitle sx={{ m: 0, p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="h6" component="div" sx={{ fontWeight: 'bold', color: 'primary.main' }}>
                    {initialData ? 'Editar Convenio' : 'Nuevo Convenio'}
                </Typography>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={CLOSE_BTN_SX}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <form onSubmit={onSubmit}>
                <DialogContent dividers>
                    <Box sx={{ mt: 1 }}>
                        <TextField
                            autoFocus
                            margin="dense"
                            id="nombre"
                            label="Nombre del Convenio"
                            type="text"
                            fullWidth
                            variant="outlined"
                            value={nombre}
                            onChange={(e) => {
                                setNombre(e.target.value);
                                setError(false);
                            }}
                            error={!!error}
                            helperText={error}
                        />
                    </Box>
                </DialogContent>
                <DialogActions sx={{ p: 2 }}>
                    <Button onClick={handleClose} color="inherit" variant="text">
                        Cancelar
                    </Button>
                    <Button type="submit" variant="contained" color="primary" sx={{ boxShadow: 3 }}>
                        {initialData ? 'Actualizar' : 'Guardar'}
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};

export default ConveniosForm;
